import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  site_title: "Подуяне Днес",
  tagline: "Независима хиперлокална медия за район Подуяне, София",
  contact_email: "redakcia@poduyane.bg",
  about_text:
    "„Подуяне Днес“ е независима хиперлокална медия за район Подуяне, София.",
  comments_enabled: true,
  comments_require_approval: false,
  maintenance_mode: false,
  maintenance_message:
    "Работим по подобрения и ще се върнем съвсем скоро. Благодарим за търпението!",
  maintenance_until: "",
  social_facebook: "",
  social_instagram: "",
  social_youtube: "",
  social_twitter: "",
  social_tiktok: "",
  social_telegram: "",
  listing_valid_days: 30,
  disclaimer_text:
    "„Подуяне Днес“ е независима медия и не носи отговорност за съдържанието на коментарите, обявите и другите материали, публикувани от потребителите.",
  terms_content: "",
  privacy_content: "",
};

export function SettingsProvider({ children }) {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: () => api.get("/settings").then((r) => r.data),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
  });

  const settings = { ...FALLBACK, ...(data || {}) };

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || FALLBACK;
}
